import React from "react";
import "./nationwide-coverage.scss";

const locations = [
  {
    state: "WA",
    city: "Perth",
    note: "Coming Soon",
    top: "57%",
    left: "28%",
  },
  {
    state: "SA",
    city: "Adelaide",
    note: "Coming Soon",
    top: "66%",
    left: "67%",
  },
  {
    state: "QLD",
    city: "Gold Coast",
    note: "",
    top: "38%",
    left: "89%",
  },
  {
    state: "NSW",
    city: "Sydney",
    note: "",
    top: "60%",
    left: "90%",
  },
  {
    state: "VIC",
    city: "Melbourne",
    note: "Head Office",
    top: "80%",
    left: "78%",
  },
];

const NationwideCoverage = () => {
  return (
    <section className="nationwide-coverage">
      <div className="nationwide-coverage-inner">
        <div className="coverage-content">
          <h2>
            Nationwide <span>Coverage</span>
          </h2>

          <p>
            With depots across Australia and a growing national fleet, we&apos;re
            ready to deliver wherever your project is.
          </p>
        </div>

        <div className="coverage-map-wrapper">
          <div className="coverage-map">
            <img
              src="/images/australia-dark.png"
              alt="Australia coverage map"
              className="coverage-map-image"
            />

            {locations.map((location, index) => (
              <div
                key={index}
                className={`coverage-location coverage-location-${location.state.toLowerCase()}`}
                style={{ top: location.top, left: location.left }}
              >
                <span className="coverage-dot"></span>

                <div className="coverage-label">
                  <div className="state">{location.state}</div>
                  <div className="city">{location.city}</div>
                  {location.note && <div className="note">{location.note}</div>}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="coverage-image-panel">
          <img
            src="/images/mr-traffic-hero-2.jpg"
            alt="Keeping Australia Moving"
          />
        </div>
      </div>
    </section>
  );
};

export default NationwideCoverage;